import {
  GET_TASKS_SUCCESS,
  GET_TASK_SUCCESS,
  CREATE_TASK_SUCCESS,
  EDIT_TASK_SUCCESS,
  DELETE_TASK_SUCCESS,
  UPDATE_TASK_STATUS_SUCCESS,
} from './task.types';

const initialState = {
  tasks: [],
  task: null,
};

export const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TASKS_SUCCESS:
      return { ...state, tasks: action.payload };
    case GET_TASK_SUCCESS:
      return { ...state, task: action.payload };
    case CREATE_TASK_SUCCESS:
      return { ...state, tasks: [...state.tasks, action.payload] };
    case EDIT_TASK_SUCCESS:
      return {
        ...state,
        task: action.payload,
        tasks: state.tasks.map((t) =>
          t._id === action.payload._id ? action.payload : t
        ),
      };
    case DELETE_TASK_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.filter((t) => t._id !== action.payload),
      };
    case UPDATE_TASK_STATUS_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map((t) =>
          t._id === action.payload._id ? action.payload : t
        ),
      };
    default:
      return state;
  }
};
